<section class="container-fluid table-container position-relative p-0">
  <aside
    [ngClass]="{ open: isOpen() }"
    class="table-columns-reorderer"
  >
    <button
      (click)="toggleTcrState()"
      class="btn--columns-settings"
      data-testid="tcr-toggle-display-button"
      mat-icon-button
      type="button"
    >
      <mat-icon>settings</mat-icon>
    </button>

    <div class="settings-box">
      <div class="hd-area">
        <div class="row">
          <div class="col-auto">
            <h3>{{ headerLabel }}</h3>
          </div>
          <div class="col text-end">
            @if (expandableArea) {
            <button
              (click)="expandTableToggler()"
              class="btn-expand"
              mat-icon-button
              type="button"
            >
              <mat-icon>{{ expandTable() ? 'unfold_less' : 'unfold_more' }}</mat-icon>
            </button>
            }
            <button
              (click)="toggleTcrState()"
              class="me-15px"
              mat-icon-button
              data-testid="tcr-close-button"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div
        (cdkDropListDropped)="cdkDropListDropped($event)"
        cdkDropList
        class="columns-drag-container"
      >
        @for (column of tableColumnsState; track column; let i = $index) {
        <div
          [cdkDragDisabled]="!isColumnAllowed(column.columnId)"
          [attr.data-testid]="'tcr--drag-col-' + column.columnId"
          cdkDrag
          cdkDragLockAxis="y"
          class="drag-item drag-col-{{ column.columnId }}"
        >
          <div
            *cdkDragPlaceholder
            class="drag-placeholder"
          ></div>
          <mat-checkbox
            (change)="column.display = $event.checked; saveAndEmitTableState()"
            [checked]="column.display === undefined ? true : column.display"
          >
            {{ column.label | translate }}
            @if (column.subHeaderLabel) {
            <div
              rs-sub-text
              data-testid="subheader-label"
            >{{ column.subHeaderLabel | translate }}</div>
            }
          </mat-checkbox>
          <i class="material-icons drag-indicator">drag_indicator</i>
        </div>
        }
      </div>
    </div>

    <ct-backdrop (click)="toggleTcrState()"></ct-backdrop>
  </aside>

  <rs-table-container>
    <ng-content />
  </rs-table-container>
</section>

<!-- backdrop to handle closing of tcr -->
@if (isOpen()) {
<div
  (click)="toggleTcrState()"
  class="backdrop"
></div>
}